import { GridSync } from '.';

export type CopyResult<T> = { data: T[]; changes: GridSync<T> };
